import classes from "./HelpPage.module.css";

const HelpPage = () => {
  const bookString =
    process.env.REACT_APP_ASSETS_URL + "/assets/icons/book_icon_thick.svg";

  return (
    <div className={classes.helpPage}  style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/backgrounds/glasses_tile.svg)`,}}>
      <div className={classes.helpPageContainer}>
        <h2 className={classes.mainHeader}>Help!</h2>

        <div className={classes.imageBlocker}>
          <img
            className={classes.innerImage}
            src={"/assets/icons/skull_icon.svg"}
            alt="new"
          />
        </div>

        <div className={classes.infoSection}>
          <p>Welcome to the backrooms! </p>
          <p>Browse our selection of cocktails and create your own books!</p>
        </div>
        <div className={classes.infoSection}>
          <h3 className={classes.infoSectionHeader}>Cocktails</h3>
          <p>
            Discover our cocktail menu to find your personal favorites or try
            something new. Select a cocktail to view the ingredients, recipe,
            and even add it to your Cart.
          </p>
        </div>
        <div className={classes.infoSection}>
          <h3 className={classes.infoSectionHeader}>Cart</h3>
          <p>
            In the top right corner of the screen, you'll find the Cart icon.{" "}
          </p>
          <img src={bookString} alt="new" className={classes.cart_image} />
          <p>
            Add cocktails to your Cart to create your own personal cocktail
            book. Once you've added all the cocktails you want to include,
            select "Create Book" to add it to your Bookshelf. To remove or
            change the quantity of a cocktail in your Cart, click or tap on the
            cocktail.
          </p>
          <p>
            Note: If the input box has a red warning when creating a new book,
            your input is invalid and will need to be changed.
          </p>
        </div>
        <div className={classes.infoSection}>
          <h3 className={classes.infoSectionHeader}>Search</h3>
          <p>
            Add ingredients to the search bar to explore the cocktails you can
            create with those ingredients.
          </p>

          <p>
            Scroll through the ingredients under the Alcohol or Mixer headings,
            or search for a specific ingredient.
          </p>

          <p>
            To remove an ingredient from the search bar, simply tap or click it.
          </p>

          <p>
            In the resulting cocktails from your search, you can select a
            cocktail to see which ingredients are included in your search
            (highlighted with a green border) and which ingredients are missing
            (highlighted with a red border).
          </p>
        </div>
        <div className={classes.infoSection}>
          <h3 className={classes.infoSectionHeader}> Cabinet</h3>
          <p>
            Add the ingredients you have at home to your Cabinet and discover
            all the cocktails you can make.
          </p>

          <p>
            If the ingredient icon is highlighted green, it indicates you have
            enough of that ingredient for the drinks currently in your Cart.
          </p>

          <p>
            To remove an ingredient from the Cabinet, simply click on the
            ingredient and then click the red subtract button.
          </p>

          <p>
            In the resulting search, select a cocktail to view a dropdown of the
            ingredients. Ingredients with a green border are in your Cabinet,
            while ingredients with a red border are missing.
          </p>
        </div>

        <div className={classes.infoSection}>
          <h3 className={classes.infoSectionHeader}>Bookshelf</h3>
          <p>
            All of the books you create will be placed on your Bookshelf. You
            can have a maxiumum of 15 books at any given time. Select a book on
            the shelf to open it.
          </p>
        </div>
        <div className={classes.infoSection}>
          <h3 className={classes.infoSectionHeader}>Books</h3>
          <p>
            Once you have selected a book from your bookshelf, you can swipe
            horizontally to navigate between the pages.
          </p>

          <p>
            The first page will list the number of each respective cocktail in
            the book and include an option to delete the book.
          </p>

          <p>
            The second page will list all the ingredients required to make the
            cocktails. Select the "Show Shopping" button to subtract the
            ingredient quantities currently in your cabinet from the shopping
            list. Select "Show Totals" to toggle back to the original
            quantities.
          </p>

          <p>
            The remaining pages will include the recipes for all the cocktails
            in the book. To close the book, select the black edge area of the
            screen.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
